import PadraoModel from 'src/core/model/PadraoModel.js'

export default class MobiautoAcessorioModel extends PadraoModel {
  recurso = 'mobiauto/acessorios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Acessórios Mobiauto';

  colunasGrid = [
  ];

  form = {
    id: null,
    name: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
